import { FC } from 'react';
import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from '@mui/material';
import { FileCheckboxListProps } from './FileCheckboxList.props';

const FileCheckboxList: FC<FileCheckboxListProps> = ({
  files,
  selectedPath,
  onSelect,
  isLoading,
  emptyLabel,
  idPrefix,
}) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
        <CircularProgress size={16} />
        <Typography variant="caption" color="text.secondary">
          Loading files…
        </Typography>
      </Box>
    );
  }

  if (!files.length) {
    return (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', py: 1 }}>
        {emptyLabel}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        maxHeight: 280,
        minHeight: 140,
        overflowY: 'auto',
        border: theme => `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        px: 1,
      }}>
      {files.map(file => (
        <FormControlLabel
          key={file.id}
          sx={{ display: 'flex', m: 0, alignItems: 'flex-start', py: 0.25 }}
          control={
            <Checkbox
              size="small"
              id={`${idPrefix}-${file.id}`}
              checked={selectedPath === file.path}
              onChange={() => onSelect(file.path)}
            />
          }
          label={
            <Typography variant="body2" sx={{ wordBreak: 'break-all', pt: 0.75 }}>
              {file.name}
            </Typography>
          }
        />
      ))}
    </Box>
  );
};

export default FileCheckboxList;
